import { $api } from "@/kibi/core/utils/api";
import type {
  PaginatedResponse,
  QueryOptions,
} from "@/kibi/core/utils/pagination_types";
import type { InjectionKey } from "vue";
import type { EmailHistoryDTO } from "../models/email_model";

export interface EmailDataSource {
  getOrgEmailHistory(
    options: QueryOptions,
  ): Promise<PaginatedResponse<EmailHistoryDTO[]>>;
  getAllEmailHistory(
    options: QueryOptions,
  ): Promise<PaginatedResponse<EmailHistoryDTO[]>>;
  getUserEmailHistory(
    userId: string,
    options: QueryOptions,
  ): Promise<PaginatedResponse<EmailHistoryDTO[]>>;
}

export const emailDataSourceKey: InjectionKey<EmailDataSource> =
  Symbol("EmailDataSource");

export class EmailDataSourceImpl implements EmailDataSource {
  async getOrgEmailHistory(
    options: QueryOptions,
  ): Promise<PaginatedResponse<EmailHistoryDTO[]>> {
    const response = await $api<PaginatedResponse<EmailHistoryDTO[]>>(
      "/emails/history",
      {
        method: "GET",
        params: options,
      },
    );
    return response;
  }

  async getAllEmailHistory(
    options: QueryOptions,
  ): Promise<PaginatedResponse<EmailHistoryDTO[]>> {
    const response = await $api<PaginatedResponse<EmailHistoryDTO[]>>(
      "/emails/history/all",
      {
        method: "GET",
        params: options,
      },
    );
    return response;
  }

  async getUserEmailHistory(
    userId: string,
    options: QueryOptions,
  ): Promise<PaginatedResponse<EmailHistoryDTO[]>> {
    const response = await $api<PaginatedResponse<EmailHistoryDTO[]>>(
      `/emails/users/${userId}/history`,
      {
        method: "GET",
        params: options,
      },
    );
    return response;
  }
}
